import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8.33333",
  cy: "5.00002",
  r: "3.33333",
  stroke: "#4B4B4B",
  "stroke-width": "1.25"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "8.33333",
  cy: "14.1666",
  rx: "5.83333",
  ry: "3.33333",
  stroke: "#4B4B4B",
  "stroke-width": "1.25"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.8333 1.66669C15.8333 1.66669 17.5 2.66669 17.5 5.00002C17.5 7.33335 15.8333 8.33335 15.8333 8.33335",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.1667 3.33331C14.1667 3.33331 15 3.83331 15 4.99998C15 6.16665 14.1667 6.66665 14.1667 6.66665",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}